import React from "react";
import { FormattedMessage } from "react-intl";
import { isBefore, parseISO } from "date-fns";
type MaintenanceMessage = {
	task_time: {
		start_time: string;
		end_time: string;
	};
	phrase_app_key: string;
	message_text: string;
	type: string;
};
export class MaintenanceMessages extends React.Component<
	{
		bsStyle: string;
		bsSize: string;
		maintenance_messages: Array<MaintenanceMessage> | null | undefined;
	},
	{
		show: boolean;
	}
> {
	static defaultProps: Record<string, any> = {
		bsStyle: "danger",
		bsSize: "lg",
	};

	constructor(props) {
		super(props);
		this.state = {
			show: true,
		};
	}

	onClick() {
		this.setState({
			show: false,
		});
	}

	pick_maintenance_message(
		maintenance_messages: Array<MaintenanceMessage> | null | undefined,
	): MaintenanceMessage | null | undefined {
		return maintenance_messages?.find(message => {
			const sys_time = new Date();
			const start_time = parseISO(message.task_time.start_time);
			const end_time = parseISO(message.task_time.end_time);
			return (
				(message.phrase_app_key || message.message_text) &&
				isBefore(start_time, sys_time) &&
				isBefore(sys_time, end_time)
			);
		});
	}

	render(): any {
		const maintenance_messages = this.props.maintenance_messages;

		if (!this.state.show || !maintenance_messages) {
			return null;
		}

		const message = this.pick_maintenance_message(maintenance_messages);

		if (message) {
			const classname = "mfcss_info-box background-" + message.type + " mfcss_info-box-" + this.props.bsSize;
			return (
				<div className="mfcss">
					<div className={classname}>
						<table>
							<tbody>
								<tr>
									<td>
										{message.phrase_app_key ? (
											<FormattedMessage id={message.phrase_app_key} />
										) : (
											message.message_text
										)}
									</td>
									<td
										className="maintenance-close-button"
										data-testid="maintenance-close-button"
										onClick={() => this.onClick()}>
										<span className="icon-close" />
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			);
		}

		return null;
	}
}
